import type { Editor, Extensions } from "@tiptap/core";
import Highlight from "@tiptap/extension-highlight";
import StarterKit from "@tiptap/starter-kit";
import { Markdown } from "tiptap-markdown";

export type SpeakerMarkdownStorage = {
  markdown?: { getMarkdown: () => string };
};

export function getSpeakerMarkdownFromEditor(editor: Editor): string {
  const storage = editor.storage as SpeakerMarkdownStorage;
  return storage.markdown?.getMarkdown() ?? editor.getText();
}

/** TipTap extensions shared by speaker script editor and read-only views. */
export function speakerScriptExtensions(): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [3] },
      bulletList: false,
      orderedList: false,
      blockquote: false,
      code: false,
      codeBlock: false,
      horizontalRule: false,
      strike: false,
    }),
    Highlight.configure({
      HTMLAttributes: { class: "speaker-md-mark" },
    }),
    Markdown.configure({
      html: true,
      transformPastedText: true,
      transformCopiedText: true,
    }),
  ];
}
